import { useState } from "react"
import rest from "../../rest"
import { Relato } from "../FormRelato/type"
import { ResumoType } from "./types"

const useStoreResumo = () => {
  const initialStore: ResumoType = {
    situacao: "",
    deliberacao: "",
    reportesandamentos: [],
  }
  const [store, _setStore] = useState<ResumoType>(initialStore)
  const [historico, setHistorico] = useState<ResumoType[]>([])
  const [ultimoResumo, setUltimoResumo] = useState<ResumoType | undefined>()
  const [error, setError] = useState<{ [index: string]: any }>({})
  const [relatos, setRelatos] = useState<Relato[]>([])
  const [success, setSuccess] = useState("")
  const [loading, setLoading] = useState("")

  const situacaoTrabalho = {
    validador: ["aguardando_validacao"],
    curador: ["em_elaboracao", "aguardando_revisao"],
  }

  const setStore = (obj: ResumoType) => {
    _setStore(Object.assign({}, store, obj))
  }

  const clearStore = () => {
    _setStore(initialStore)
  }

  const checkError = (field: string) => {
    if (error[field]) {
      const fieldError = error[field]
      if (Array.isArray(fieldError)) {
        return fieldError[0]
      } else {
        return fieldError
      }
    } else {
      return null
    }
  }

  const checkLoading = (action: string) => loading === action

  const clearError = () => {
    setError({})
    setSuccess("")
  }

  const list = async (idItem: number, situacaoTrabalho: string[]) => {
    try {
      const json: { results: any[] } = await rest(
        `resumo/?itemtrabalho=${idItem}`
      )
      if (json.results.length) {
        const historico = json.results.filter((e: any) => {
          return !situacaoTrabalho.includes(e.alias_situacao)
        })
        const work = json.results.find(
          (e) => !historico.map((h) => h.id).includes(e.id)
        )
        if (work) {
          setStore(work)
        } else {
          clearStore()
        }
        const lastResumo = historico.reduce((p, c) => (p?.id > c?.id ? p : c))
        setUltimoResumo(lastResumo)
        setHistorico(historico.filter((e) => e.id !== lastResumo.id))
      }
      return json.results
    } catch (e) {
      setError(e)
      return []
    }
  }

  const listRelato = async (idItem: number, idResumo?: number) => {
    try {
      const json: { results: Relato[] } = await rest(
        `reporteandamento/?page_size=10000&itemtrabalho=${idItem}`
      )
      if (json.results.length) {
        const validados = idResumo
          ? json.results.filter(
            (e) =>
              (!e.resumo || e.resumo === idResumo) &&
              e.alias_situacao === "validado"
          )
          : json.results.filter(
            (e) => !e.resumo && e.alias_situacao === "validado"
          )
        setRelatos(validados)
      }
    } catch (e) {
      setError(e)
    }
  }

  const get = async () => {
    try {
      clearError()
      setLoading("get")
      const json = await rest(`resumo/${store.id}/`)
      _setStore(json)
    } catch (e) {
      setError(e)
    }
    setLoading("")
  }

  const create = async () => {
    const json = await rest("resumo/", "POST", store)
    _setStore(json)
    return json
  }

  const save = async () => {
    try {
      clearError()
      setLoading("save")
      const json = store.id
        ? await rest(`resumo/${store.id}/`, "PUT", store)
        : await rest("resumo/", "POST", store)
      _setStore(json)
      setSuccess("Salvo com sucesso")
    } catch (e) {
      setError(e)
    }
    setLoading("")
  }

  const excluir = async () => {
    try {
      clearError()
      setLoading("excluir")
      await rest(`resumo/${store.id}/`, "DELETE")
      setSuccess("Excluído com sucesso")
    } catch (e) {
      setError(e)
    }
    setLoading("")
  }

  const enviar = async () => {
    try {
      const action =
        store.alias_situacao === "aguardando_revisao"
          ? "concluir-revisao"
          : "enviar"
      clearError()
      setLoading("enviar")
      const resumo = store.id ? store : await create()
      resumo.itemtrabalho_id = store.itemtrabalho_id
      await rest(`resumo/${resumo.id}/${action}/`, "POST", resumo)
      setSuccess("Enviado com sucesso")
    } catch (e) {
      setError(e)
    }
    setLoading("")
  }

  const solicitarRevisao = async () => {
    try {
      clearError()
      setLoading("solicitarRevisao")
      await rest(`resumo/${store.id}/solicitar-revisao/`, "POST", store)
      setSuccess("Devolvido com sucesso")
    } catch (e) {
      setError(e)
    }
    setLoading("")
  }

  const validar = async () => {
    try {
      clearError()
      setLoading("validar")
      await rest(`resumo/${store.id}/validar/`, "POST", store)
      setSuccess("Validado com sucesso")
    } catch (e) {
      setError(e)
    }
    setLoading("")
  }

  const api = {
    setStore,
    checkError,
    checkLoading,
    list,
    get,
    save,
    excluir,
    enviar,
    solicitarRevisao,
    validar,
    listRelato,
  }

  return { store, success, api, relatos, ultimoResumo, situacaoTrabalho }
}

export default useStoreResumo
